import React from 'react';
import PropTypes from 'prop-types';
import { If, IfProps } from './If';

interface ChooseProps {
  children?: React.ReactNode;
}

interface OtherwiseProps {
  render?: () => React.ReactNode;
  children?: React.ReactNode;
}

export const Choose = (props: ChooseProps): any => {
  let when: React.ReactNode = null;
  let otherwise: React.ReactNode = null;

  React.Children.forEach(props.children, (child) => {
    if (!React.isValidElement(child)) {
      return;
    }
    const childProps = child.props as IfProps;
    if (childProps.condition === undefined) {
      otherwise = child;
    } else if (!when && childProps.condition === true) {
      when = child;
    }
  });

  return when || otherwise;
};

Choose.propTypes = {
  children: PropTypes.node,
};

Choose.When = If;

const Otherwise = ({ render, children }: OtherwiseProps): any =>
  render ? render() : children;

Otherwise.propTypes = {
  children: PropTypes.node,
  render: PropTypes.func,
};

Choose.Otherwise = Otherwise;
